// extracted by mini-css-extract-plugin
export var checkoutInfoButton = "styles-module--checkoutInfoButton--1EDx8";
export var checkoutInfoContent = "styles-module--checkoutInfoContent--1H739";